import { Box } from '@mui/system'

export default function NotFound() {
    return <Box>Could not find the customer</Box>
}
